import {useLocation} from 'react-router-dom';
import {LoanRequestStatus} from '../../myAccount/my-credits/consts/loanStatus';

// Function to handle routing based on loan request status and type
export const navigateToStep = (loan?: ILoanRequestItem): string | undefined => {
  if (!loan) return undefined;

  const status = Number(loan.status);

  // Direct loans routing
  if (loan.is_direct === true) {
    switch (status) {
      case LoanRequestStatus.SUBMITTED:
      case LoanRequestStatus.PENDING_VALIDATION:
      case LoanRequestStatus.FINISHED_VALIDATION:
        return '/receive-loan/step-1';
      case LoanRequestStatus.PENDING_LOAN_TYPE:
        return '/receive-loan/step-2';
      case LoanRequestStatus.PENDING_BANK_ACCOUNT_VALIDATION:
      case LoanRequestStatus.FILLING_DOCUMENT:
        return '/receive-loan/step-3';
      case LoanRequestStatus.PENDING_FINAL_REVIEW:
      case LoanRequestStatus.COMPLETED:
      case LoanRequestStatus.REJECTED_LOAN_REQUEST:
        return '/receive-loan/step-4';
      default:
        return undefined;
    }
  }

  // Non-direct loans routing
  if (loan.is_direct === false) {
    switch (status) {
      // اعتبار سنجی
      case LoanRequestStatus.SUBMITTED:
      case LoanRequestStatus.PENDING_VALIDATION:
      case LoanRequestStatus.FINISHED_VALIDATION:
        return '/receive-credit/step-1';
      // انتخاب اعتبار
      case LoanRequestStatus.PENDING_LOAN_TYPE:
        return '/receive-credit/step-2';
      case LoanRequestStatus.FILLING_DOCUMENT:
        return '/receive-credit/step-3';
      // ساخت امضا دیجیتال
      case LoanRequestStatus.DOCUMENT_FILLED:
      case LoanRequestStatus.PENDING_DIGITAL_SIGN:
        return '/receive-credit/step-4';
      // تخصیص اعتبار
      case LoanRequestStatus.FINISHED_DIGITAL_SIGN:
      case LoanRequestStatus.PENDING_FINAL_REVIEW:
        return '/receive-credit/step-5';
      // رد شدن وام
      case LoanRequestStatus.REJECTED_LOAN_REQUEST:
      case LoanRequestStatus.REJECTED_BANK_ACCOUNT:
        return '/receive-credit/step-6';

      default:
        return undefined;
    }
  }

  return undefined;
};

export const useIsLoanInStep = (loan?: ILoanRequestItem): boolean => {
  const {pathname} = useLocation();

  const expectedPath = navigateToStep(loan);

  if (!expectedPath) return false;

  // remove anything after /step-n
  const currentStepRoot = pathname.match(/^.*\/step-\d+/)?.[0];

  return currentStepRoot === expectedPath;
};
